import React from "react";

import {
    Autocomplete,
    Button,
    FilterRemoveIcon,
    Heading,
    IconButton,
    Pane,
    SelectField,
    TextInputField, toaster,
    Tooltip
} from "evergreen-ui";
import {useDispatch, useSelector} from "react-redux";
import {equationsSelector, selectorStationsForFilters} from "../periodValuesFilterApi";
import {findFirstByName} from "../common/matchMethods";
import {saveRainTemplate} from "./ApiCalls";
import {
    addNewFilter,
    deleteFilter,
    selectCatchmentArea,
    selectCoefficientA,
    selectCoefficientB,
    selectCoefficientC,
    selectCoefficientD,
    selectEquation, selectLevelCode,
    selectLevelDatasourceType,
    selectLevelEntity, selectRainfallCode,
    selectRainfallDatasourceType,
    selectRainfallEntity,
    selectStation,
    setNewRainFloodConstructor
} from "./rainFloodSlice";
import {getDatasourceTypesByStation} from "../decadeConstructor/ApiCalls";
import CreateOutputFormRainFloodDialog from "./CreateOutputFormRainFloodDialog";
import {getRainFloodConstructorRights} from "../../Privileges/PrivilegesSelectors";
import CoefficientsComponent, {
    checkCoefficients,
    checkCoefficientsWithoutPush
} from "../flood/common/CoefficientsComponent";
import FloodFilterPanel from "../flood/common/FloodFilterPanel";
import CreateTemplateDialog from "../common/CreateTemplateDialog";
import {floodObject} from "../flood/model/FloodObjects";
import RainFloodTable from "./RainFloodTable";
import {createFullStationName, createFullStationNameWithOuterIdx} from "../Constructor.DefaultPage";
import {AutoCompleteConstructor} from "../../BaseConstructor/BaseConstructor";

export default function RainFloodPage({isEdit, isFullInfo}) {
    const dispatch = useDispatch();
    const privileges = useSelector(state => state.login.privileges)

    const rights = getRainFloodConstructorRights(privileges)
    const equations   = useSelector(equationsSelector);


    const stations = useSelector(selectorStationsForFilters);

    const rainFloodConstructor = useSelector(state => state.rainFloodConstructor)


    const [dsourceTypes, setDsourceTypes] = React.useState([])

    const [isFormShown, setIsShown] = React.useState(false)

    const [createTemplateShown, setCreateTemplateShown] = React.useState(false)
    const setCreateTemplateShownCallback = (shown) => setCreateTemplateShown(shown)

    const [idx, setIdx] = React.useState(chooseIdx())

    const setIsShownCallback = (shown) => {
        // if (checkCoefficients()) {
            setIsShown(shown)
        // }
    }

    function chooseIdx() {
        for (let i = 0; i < stations.length; i++) {
            if (stations[i].name === rainFloodConstructor.station.name)
                return stations[i].idx
        }
        return undefined
    }

    function onSelectStation(selectedItem) {
        clearFilter()
        setIdx(
            selectedItem.split("] ")[0]
                .replace("[", "")
        )
        selectedItem = selectedItem.split("] ")[1]
        let res = findFirstByName(stations, selectedItem)

        getDatasourceTypesByStation(res.id).then((result) => {
            setDsourceTypes(result.data)
            res = {id: res.id, name: res.name, sourcesTypes: result.data}
            dispatch(selectStation(res));
        })
    }

    function clearFilter() {
        dispatch(setNewRainFloodConstructor({...floodObject}))
    }

    React.useEffect(() => {
        if (isEdit) {
            setDsourceTypes(rainFloodConstructor.station.sourcesTypes)
        }
    })

    function isEquationDisabled() {
        return rainFloodConstructor.filters[rainFloodConstructor.filters.length - 1].level.code.id === -1
    }

    function isCreateTemplateDisabled() {
        return !(rainFloodConstructor.station.id !== -1
            && rainFloodConstructor.filters[rainFloodConstructor.filters.length - 1].level.code.id !== -1
            && rainFloodConstructor.filters[rainFloodConstructor.filters.length - 1].rainfall.code.id !== -1
            && rainFloodConstructor.equation !== "-1"
            && rainFloodConstructor.equation !== ""
            && rainFloodConstructor.catchmentArea !== ""
            && checkCoefficientsWithoutPush(rainFloodConstructor.coefficients, rainFloodConstructor.equation)
            )
    }

    function isOutputFormDisabled() {
        return isCreateTemplateDisabled()
    }

    return (
        <Pane display="block"  marginBottom={80}>
            <Heading size={600}>Конструктор "Дождевых паводков"</Heading>

            <Pane display="flex" columnGap={10} marginBottom={45} marginTop={5}>
                <Pane>
                    <Pane marginBottom={5}>
                        Станция
                    </Pane>
                    {AutoCompleteConstructor(
                        onSelectStation,
                        rainFloodConstructor,
                        idx,
                        stations,
                        isFullInfo,
                        createFullStationNameWithOuterIdx,
                        createFullStationName
                    )}
                </Pane>
            </Pane>

            <FloodFilterPanel constructor={rainFloodConstructor}
                              isFullInfo={isFullInfo}
                              onAddFilter={() => dispatch(addNewFilter())}
                              onDeleteFilter={deleteFilter}
                              onSelectDatasourceTypeForRainfall={selectRainfallDatasourceType}
                              onSelectDatasourceTypeForLevel={selectLevelDatasourceType}
                              onSelectCodeForLevel={selectLevelCode}
                              onSelectCodeForRainfall={selectRainfallCode}
                              onSelectEntityForRainfall={selectRainfallEntity}
                              onSelectEntityForLevel={selectLevelEntity}
            />

            <Pane display={'flex'} columnGap={80}>
                <Pane marginTop={3}>
                    <SelectField label={"Уравнение для расчета расхода воды"}
                                 disabled={isFullInfo || isEquationDisabled()}
                                 value={typeof rainFloodConstructor.equation === 'string' ? rainFloodConstructor.equation : rainFloodConstructor.equationString}
                                 onChange={e => dispatch(selectEquation(e.target.value))}
                    >
                        <option value={-1}>Выберите уравнение</option>
                        {equations.map(eq => <option value={eq.equationString}>{eq.equationString}</option>)}
                    </SelectField>
                </Pane>
                <Pane>
                    <CoefficientsComponent
                        isFullInfo={isFullInfo}
                        coefficients={rainFloodConstructor.coefficients}
                        onSelectA={selectCoefficientA}
                        onSelectB={selectCoefficientB}
                        onSelectC={selectCoefficientC}
                        onSelectD={selectCoefficientD}
                    />
                </Pane>
            </Pane>

            <TextInputField
                label={"Площадь водосбора"}
                type={"number"}
                step={"any"}
                disabled={isEquationDisabled() || isFullInfo}
                onChange={e => dispatch(selectCatchmentArea(e.target.value))}
                value={rainFloodConstructor.catchmentArea}
                width={220}
                marginTop={10}
                placeholder="Площадь водосбора"
            />

            {
                !isFullInfo && !isEdit ?
                    <Pane>
                        {
                            rights.canSaveTemplate ?
                                isCreateTemplateDisabled() ?
                                    <Tooltip content={"Выберите фильтры"}>
                                        <Pane display={"inline"}>
                                            <Button marginRight={10}
                                                    marginTop={10}
                                                    disabled={true}>Сохранить шаблон</Button>
                                        </Pane>
                                    </Tooltip> :
                                    <Button marginRight={10}
                                            marginTop={10}
                                            onClick={() => {if (checkCoefficients(rainFloodConstructor.coefficients, rainFloodConstructor.equation)) setCreateTemplateShown(true)}}
                                            disabled={false}>Сохранить шаблон</Button>

                                : <></>
                        }
                        {
                            rights.canCreateOutputForm ?
                                isOutputFormDisabled() ?
                                    <Tooltip content={"Выберите фильтры"}>
                                        <Pane display={"inline"}>
                                            <Button disabled={true} marginTop={10}>Выгрузить выходную форму</Button>
                                        </Pane>
                                    </Tooltip> :
                                    <Button onClick={() => {if (checkCoefficients(rainFloodConstructor.coefficients, rainFloodConstructor.equation)) setIsShown(true); }}
                                            disabled={false}
                                            marginTop={10}>Выгрузить выходную форму</Button>
                                : <></>
                        }
                        <Tooltip content="Сбросить">
                            <IconButton marginTop={10} marginLeft={10} icon={FilterRemoveIcon} onClick={() => clearFilter()}/>
                        </Tooltip>
                    </Pane> : <></>

            }


            {isEdit || isFullInfo ? <></> : <RainFloodTable/>}

            <CreateTemplateDialog isShown={createTemplateShown}
                                  setIsShown={setCreateTemplateShownCallback}
                                  createTemplate={
                                      (templateName) => {
                                          saveRainTemplate(rainFloodConstructor, templateName)
                                      }}
            />

            <CreateOutputFormRainFloodDialog
                constructor={rainFloodConstructor}
                isShown={isFormShown}
                setIsShown={setIsShownCallback}
                viaTemplateId={false}
                name={""}
            />



        </Pane>
    )

}
